import { combineReducers } from '@reduxjs/toolkit';
import generalInfoSlice from './general/generalSlice';
import emailConfigSlice from './email/emailSlice';
import googleConfigSlice from './google/googleSlice';
import emailLogsSlice from './emailogs/emailogsSlice';
import hubspotInfoSlice from './hubspot/hubspotSlice';
import submittalCoverPageSlice from './submittalcoverpage/submittalcoverpageSlice';

const settingsSlice = combineReducers({
    general: generalInfoSlice,
    email: emailConfigSlice,
    google: googleConfigSlice,
    emailogs: emailLogsSlice,
    hubspot: hubspotInfoSlice,
    submittalcoverpage: submittalCoverPageSlice,
});

export default settingsSlice;
